export const GOOGLE_MAPS_CONFIG = {
    id: "google-maps",
    version: "weekly",
    libraries: ["places", "drawing", "visualization"] as const,
    language: "pt-BR",
    region: "BR",
}
